export const services = [
  {
    title: 'Parking Lincensing Services',
    description:
      'Manage parking permits,fines and related fees for public parking throughout the country.',
    imageSrc: '/services/parking.svg',
  },
  {
    title: 'Health Services',
    description:
      'Access and pay for hospital services, NHIF contributions, health permits, public health licenses, and more',
    imageSrc: '/services/health_services.svg',
  },
  {
    title: 'Business lincensing Services',
    description:
      'Obtain business licenses, permits and registration to operate within the County.',
    imageSrc: '/services/business_licensing.svg',
  },
  {
    title: 'Essential Services',
    description:
      'Arrange payments for essential services like fire brigade, waste disposal, and emergency responses.',
    imageSrc: '/services/essential_services.svg',
  },
  {
    title: 'Land Services',
    description:
      'Process land transactions, title deeds, land rates, and other land-related services',
    imageSrc: '/services/land_services.svg',
  },
  {
    title: 'Property Services',
    description:
      'Handle property taxes, land rates, and other property-related matters across the county',
    imageSrc: '/services/property_services.svg',
  },
  {
    title: 'Advertisement Services',
    description:
      'Request advertising permits, pay billboard fees, and access other advertising-related services.',
    imageSrc: '/services/advertising_services.svg',
  },
  {
    title: 'Records Management',
    description:
      'Create, store, retrieve, and archive official records securely across departments with full auditability.',
    imageSrc: '/services/other_services.svg',
  },
  {
    title: 'Environment & Natural Resources',
    description:
      'Services related to environmental protection and natural resources, including pollution control, waste management, and management of public open spaces.',
    imageSrc: '/services/other_services.svg',
  },

  {
    title: 'Other Services',
    description:
      'Explore and manage various other services provided by county government.',
    imageSrc: '/services/other_services.svg',
  },
];
